import React, { Component } from 'react';
import './Styles.css';


class P1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
    };

  }


  componentDidMount() {
    
  }



  render() {
    return (
      <div className="height" >
        <hr className="spacer"></hr>
        Uchi
        <hr className="spacer"></hr>
        Uchi
        <hr className="spacer"></hr>
        Uchi
        <hr className="spacer"></hr>
        Uchi
      </div>
      )
  }
};

export default P1;



// WEBPACK FOOTER //
// ./src/Templates/webpage1.js